// used by AppModals to open the ConductorModal
export const OPEN_CONDUCTOR_MODAL_QUERY_PARAM_KEY = "open_conductor_modal";

// for ConductorModal to identify the modal content
export const CONDUCTOR_MODAL_CONTENT_IDENTIFIER_QUERY_PARAM_KEY =
  "modal_identifier";
